import React, { useEffect, useState } from 'react';
import './Styles.css';
import { Ui32Settings } from '@ids/react-icons';
import OutsideClickHandler from '../../Elements/OutsideClickHandler';
import CustomRadioButton from '../../Elements/ids/InputElements/RadioButton';
import { ServiceClient } from '../../Services/ServiceClient';
import { useNavigate } from 'react-router-dom';
import ErrorMessage from '../../Elements/ErrorMessage';
import { formatMessage } from '../../Localization/formatMessage';
import Messages from '../../Localization/Messages';
import { useGlobalContext } from '../../context/GlobalContext';
import { BusinessArea } from '../../Enums/BusinessArea';

const legalUnitCode = {
  Sweden: 'SE',
  Norway: 'NO',
  Denmark: 'DK',
  Finland: 'FI',
};

const CustomHeader = ({ updateGlobalContext }) => {
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);
  const [userPreferences, setUserPreferences] = useState(null);
  const [error, setError] = useState(null);

  const navigate = useNavigate();
  const { globalContext } = useGlobalContext();

  useEffect(() => {
    ServiceClient.getUserPreferences(
      data => {
        setUserPreferences(data);
        updateGlobalContext({
          ...globalContext,
          legalUnit: data.legalUnit,
          businessArea: data.businessArea,
        });
      },
      () => {
        setError(formatMessage(Messages.customHeader_error_cannotFetch));
      }
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const updateUserPreferences = preferences => {
    ServiceClient.updateUserPreferences(
      preferences,
      () => {},
      () => {
        setError(formatMessage(Messages.customHeader_error_cannotUpdate));
      }
    );
  };

  const updateAfterLegalUnitChange = legalUnit => {
    setUserPreferences({ ...userPreferences, legalUnit: legalUnit });
    updateGlobalContext({ ...globalContext, legalUnit: legalUnit });
    updateUserPreferences({ legalUnit: legalUnit });
  };

  return (
    <header>
      <div className="customHeader-logoContainer">
        <img
          aria-hidden
          className="customHeader-logo clickable"
          src="/assets/logo.png"
          alt="Sales Agent logo"
          onClick={() => navigate('/')}
        />
        <div>Sales Agent App</div>
      </div>
      <div>
        <Ui32Settings className="clickable" onClick={() => setIsSettingsOpen(!isSettingsOpen)} />
      </div>
      <OutsideClickHandler onOutsideClick={() => setIsSettingsOpen(false)}>
        <div className={`customHeader-settings ${isSettingsOpen ? 'customHeader-settings-open' : ''}`}>
          <div className="customHeader-settings-section">
            <div className="customHeader-settings-sectionTitle">
              {formatMessage(Messages.customHeader_settings_businessArea)}
            </div>
            <CustomRadioButton
              label={formatMessage(Messages.customHeader_settings_private)}
              checked={userPreferences?.businessArea === BusinessArea.Private}
              onChange={() => {
                setUserPreferences({ ...userPreferences, businessArea: BusinessArea.Private });
                updateGlobalContext({ ...globalContext, businessArea: BusinessArea.Private });
                updateUserPreferences({ businessArea: BusinessArea.Private });
              }}
            />
            <CustomRadioButton
              label={formatMessage(Messages.customHeader_settings_commercial)}
              checked={userPreferences?.businessArea === BusinessArea.Commercial}
              onChange={() => {
                setUserPreferences({ ...userPreferences, businessArea: BusinessArea.Commercial });
                updateGlobalContext({ ...globalContext, businessArea: BusinessArea.Commercial });
                updateUserPreferences({ businessArea: BusinessArea.Commercial });
              }}
            />
          </div>

          <div className="customHeader-settings-section">
            <div className="customHeader-settings-sectionTitle">
              {formatMessage(Messages.customHeader_settings_legalUnit)}
            </div>
            <CustomRadioButton
              label={formatMessage(Messages.customHeader_settings_sweden)}
              checked={userPreferences?.legalUnit === legalUnitCode.Sweden}
              onChange={() => {
                updateAfterLegalUnitChange(legalUnitCode.Sweden);
              }}
            />
            <CustomRadioButton
              label={formatMessage(Messages.customHeader_settings_norway)}
              checked={userPreferences?.legalUnit === legalUnitCode.Norway}
              onChange={() => {
                updateAfterLegalUnitChange(legalUnitCode.Norway);
              }}
            />
            <CustomRadioButton
              label={formatMessage(Messages.customHeader_settings_denmark)}
              checked={userPreferences?.legalUnit === legalUnitCode.Denmark}
              onChange={() => {
                updateAfterLegalUnitChange(legalUnitCode.Denmark);
              }}
            />
            <CustomRadioButton
              label={formatMessage(Messages.customHeader_settings_finland)}
              checked={userPreferences?.legalUnit === legalUnitCode.Finland}
              onChange={() => {
                updateAfterLegalUnitChange(legalUnitCode.Finland);
              }}
            />
          </div>
          <ErrorMessage message={error} />
        </div>
      </OutsideClickHandler>
    </header>
  );
};

export default CustomHeader;
